export default __webpack_public_path__ + "static/media/openness2Img3.2b057273.png";